"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var Edit_1 = __importDefault(require("@material-ui/icons/Edit"));
var Clear_1 = __importDefault(require("@material-ui/icons/Clear"));
var IconButton_1 = __importDefault(require("../../../IconButton"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            borderBottom: "1px solid " + theme.palette.grey[200],
            '&:hover': {
                backgroundColor: '#FAFAFA',
            },
        },
        editButtons: {
            position: 'absolute',
            right: 0,
            display: 'flex',
        },
    });
});
var DeckCategoryEditorItem = function (_a) {
    var category = _a.category, onClickEdit = _a.onClickEdit, onClickDelete = _a.onClickDelete;
    var classes = exports.useStyles();
    return (react_1.default.createElement(core_1.ListItem, { button: true, disableRipple: true, className: classes.root },
        react_1.default.createElement(core_1.ListItemText, null, category),
        react_1.default.createElement("div", { className: classes.editButtons },
            react_1.default.createElement(IconButton_1.default, { onClick: onClickEdit },
                react_1.default.createElement(Edit_1.default, null)),
            react_1.default.createElement(IconButton_1.default, { onClick: onClickDelete },
                react_1.default.createElement(Clear_1.default, null)))));
};
exports.default = DeckCategoryEditorItem;
//# sourceMappingURL=DeckCategoryEditorItem.js.map